import React from 'react'
import { graphql, Link, navigate } from 'gatsby'
import SEO from '../components/SEO'
import * as style from '../styles/components/thoughts.module.scss'

type ThoughtsProps = {
	data: {
		allMarkdownRemark: {
			edges: {
				node: {
					id: string
					frontmatter: {
						title: string
						date: string
						tags: string[]
						language: string
					}
					fields: {
						slug: string
					}
				}
				map: Function
			}
		}
	}
	pageContext: {
		name: string
	}
}

type PostProps = {
	id: string
	frontmatter: {
		title: string
		date: string
		tags: string[]
	}
	fields: {
		slug: string
	}
}

const Tag = ({ data, pageContext }: ThoughtsProps ) => {
	const tagRedirect = (category: string, event: any) => {
		const slug = category.replace(/\s/g, '-').toLowerCase()
		event.preventDefault()
		navigate(`/tag/${slug}`)
	}

	return (
		<>
			<SEO title={`Thoughts — ${pageContext.name}`}  />
			<h1>
				Language: {pageContext.name}
			</h1>
			<div className={style.postsWrapper}>
				{data.allMarkdownRemark.edges.map(( { node } : { node: PostProps } ) => (
					<div key={node.id} className={style.post}>
						<Link to={node.fields.slug}>
							<div className={style.informations}>
								<p className={style.title}>{node.frontmatter.title}</p>
								<p className={style.date}>{node.frontmatter.date}</p>
							</div>
							<div className={style.bottom}>
								<div className={style.tags}>
									{node.frontmatter.tags.map(( category, index ) => (
										<button onClick={(event) => tagRedirect(category, event)} key={index} role="link">{category}</button>
									))}
								</div>
								<Link to={`/language/${pageContext.name}/`} role="link" className={pageContext.name === 'english' ? style.english : style.polish}></Link>
							</div>
						</Link>
					</div>
				))}
			</div>
		</>
	)
}

export default Tag

export const query = graphql`
	query($language: String!) {
		allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }, filter: {frontmatter: {language: {in: [$language]}}}) {
            edges {
                node {
                    id
                    frontmatter {
                        title
                        date(formatString: "Do [of] MMMM, YYYY")
                        tags
						language
                    }
                    fields {
                        slug
                    }
                }
            }
        }
	}
`